import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './HrUploadFile.css';

const HR_ROOT = process.env.REACT_APP_HR_START_PATH || '/hr';

function HrUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={HR_ROOT}
      sessionPrefix="hr_file"
    />
  );
}

HrUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default HrUploadFile;
